import axios from "axios";

export const AUTHORIZATION = 'Authorization';
export const BEARER = 'AuthToken ';
export const EDITION = '1.1.0'; // 版本
export const SYSTEM_NAME = '综合能源监管产教融合创新实践平台'; ///系统名称
export const SYSTEM_NAME_EN = 'Integrated Energy Regulatory Industry Education Integration Innovation Practice Platform'; ///系统名称
export const COMPANY = 'pg技术支持'; // 公司名
export const PHONE = '15983889999'; // 联系方式
export const RECORD_NUMBER = '11111'; //备案号

export const QUERY = 'QUERY';

export const SYS_BASE_URL = '/general-service'; // 基础url
export const SYS_BASE_URL_ZH = '/zh-service';

export const CREATE = 'success';
export const UPDATE = 'primary';
export const DELETE = 'danger';
export const DETAIL = 'info';
export const UNBIND = 'unbind';
export const BIND = 'bind';
export const UNBIND_API = 'unbindApi';
export const BIND_API = 'bindApi';

export const SYS_DEF = "00";

export const REALRTME_URL = "http://8.146.200.113:8000";//实时数据库域名
// export const REALRTME_URL = "http://192.168.1.63"//实时数据库域名

export const PICTURE_URL = axios.get(SYS_BASE_URL+'/api/upload/getCurrentIp').then(res => {
    return res.data.data
}); //图片前缀